import { observe } from "./reactive";
import { identity } from "lodash";
export class StateStack {
    constructor() {
        this.canUndo = observe(false);
        this.canRedo = observe(false);
        this.state = {
            current_state: undefined,
            undo: [],
            redo: []
        };
    }
    update() {
        this.canUndo.set(this.state.undo.length > 0);
        this.canRedo.set(this.state.redo.length > 0);
    }
    pushState(value) {
        if (this.state.current_state !== undefined) {
            this.state.undo.push(this.state.current_state);
        }
        this.state.current_state = value;
        this.state.redo = [];
        this.update();
    }
    undo() {
        if (this.state.undo.length > 0) {
            this.state.redo.push(this.state.current_state);
            this.state.current_state = this.state.undo.pop();
            this.update();
            return this.state.current_state;
        }
    }
    redo() {
        if (this.state.redo.length > 0) {
            this.state.undo.push(this.state.current_state);
            this.state.current_state = this.state.redo.pop();
            this.update();
            return this.state.current_state;
        }
    }
    reset() {
        this.state.undo = [];
        this.state.redo = [];
        this.state.current_state = undefined;
        this.update();
    }
}
export class UndoRedo {
    constructor(apply_state) {
        this.apply_state = apply_state;
        this.stack = new StateStack();
        this.canUndo = this.stack.canUndo.map(identity);
        this.canRedo = this.stack.canRedo.map(identity);
    }
    undo() {
        if (this.stack.canUndo.value()) {
            return this.apply_state(this.stack.undo());
        }
    }
    redo() {
        if (this.stack.canRedo.value()) {
            return this.apply_state(this.stack.redo());
        }
    }
}
